module.exports = __webpack_public_path__ + "img/four2Orange.06c7da64.png";